import { useState } from 'react';
import { Banknote } from 'lucide-react';
import { toTitleCasePt } from '../../utils/formatters';

function BillingModal({ clientName, processLabel, onConfirm, onClose }) {
  const [amount,      setAmount]      = useState('');
  const [dueDate,     setDueDate]     = useState(() => {
    const d = new Date(); d.setDate(d.getDate() + 30);
    return d.toISOString().slice(0, 10);
  });
  const [description, setDescription] = useState('');
  const [busy,        setBusy]        = useState(false);

  const handleSubmit = async () => {
    const v = parseFloat(String(amount).replace(',', '.'));
    if (!v || v <= 0) return;
    setBusy(true);
    try { await onConfirm({ amount: v, dueDate, description }); }
    finally { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 z-[500] flex items-center justify-center bg-black/40 backdrop-blur-sm" onClick={onClose}>
      <div className="bg-white rounded-2xl shadow-2xl border border-gray-200 w-full max-w-sm mx-4 overflow-hidden" onClick={(e) => e.stopPropagation()}>
        <div className="bg-[#20243B] px-5 py-4 flex items-center gap-3">
          <Banknote className="w-5 h-5 text-[#C5A059] flex-shrink-0" />
          <div>
            <div className="text-[11px] font-black uppercase tracking-widest text-[#C5A059]">Faturar Honorários</div>
            <div className="text-[10px] text-white/70 truncate max-w-[220px]">{toTitleCasePt(clientName)} {processLabel ? `— ${String(processLabel).slice(0, 40)}` : ''}</div>
          </div>
        </div>
        <div className="px-5 py-4 space-y-3">
          <div>
            <label className="text-[10px] font-bold text-gray-600 block mb-1">Valor dos Honorários (R$) *</label>
            <input
              type="text"
              inputMode="decimal"
              placeholder="Ex.: 1500,00"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              className="w-full text-sm font-bold border border-gray-300 rounded-lg px-3 py-2 outline-none focus:border-[#C5A059]"
            />
          </div>
          <div>
            <label className="text-[10px] font-bold text-gray-600 block mb-1">Vencimento</label>
            <input
              type="date"
              value={dueDate}
              onChange={(e) => setDueDate(e.target.value)}
              className="w-full text-xs border border-gray-300 rounded-lg px-3 py-2 outline-none focus:border-[#C5A059]"
            />
          </div>
          <div>
            <label className="text-[10px] font-bold text-gray-600 block mb-1">Descrição (opcional)</label>
            <input
              type="text"
              placeholder="Ex.: Honorários contrato de prestação de serviços"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              className="w-full text-xs border border-gray-300 rounded-lg px-3 py-2 outline-none focus:border-[#C5A059]"
            />
          </div>
          <div className="bg-amber-50 border border-amber-200 rounded-lg px-3 py-2 text-[10px] text-amber-800">
            O sistema irá <strong>gerar o PDF</strong>, <strong>salvar no Drive</strong>, registrar no <strong>ledger financeiro</strong> e <strong>solicitar assinatura via Clicksign</strong> automaticamente.
          </div>
        </div>
        <div className="px-5 pb-5 flex gap-2">
          <button type="button" onClick={onClose} className="flex-1 py-2 rounded-lg border border-gray-300 text-xs font-bold text-gray-600 hover:bg-gray-50 transition">Cancelar</button>
          <button
            type="button"
            onClick={handleSubmit}
            disabled={busy || !String(amount).trim()}
            className="flex-1 py-2 rounded-lg bg-[#20243B] text-[#C5A059] text-xs font-extrabold uppercase tracking-widest hover:bg-[#2d3352] disabled:opacity-50 transition"
          >
            {busy ? 'Processando...' : 'Faturar'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default BillingModal;
